import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import API_URL from '../../config';

const ListIncubationCenter = () => {
    const navigate = useNavigate();
    const [incubations, setIncubations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchIncubations = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_URL}/api/incubation/incubations-list`);

            if (response.data.success) {
                setIncubations(response.data.data || []);
            } else {
                toast.error(response.data.message || "Failed to fetch list");
            }
        } catch (err) {
            toast.error(
                err.response?.data?.message || "Error fetching incubation centers"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchIncubations();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this incubation center?")) {
            try {
                const response = await axios.delete(`${API_URL}/api/incubation/incubation-delete`, {
                    headers: { 'x-incubation-id': id }
                });

                if (response.data.success) {
                    toast.success("Incubation center deleted successfully");
                    setIncubations(prev => prev.filter(item => item._id !== id));
                } else {
                    toast.error(response.data.message || "Failed to delete");
                }
            } catch (err) {
                toast.error(
                    err.response?.data?.message || "Error deleting incubation center"
                );
            }
        }
    };

    const filteredIncubations = incubations.filter(item =>
        (item.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.city || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.email || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="container-fluid py-4">
            <div className="row">
                <div className="col-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header border-bottom bg-transparent py-3 d-flex justify-content-between align-items-center">
                            <h5 className="mb-0 fw-semibold text-dark">Incubation Centers List</h5>
                            <button className="btn btn-primary btn-sm" onClick={() => navigate('/incubation/add')}>
                                + Add Center
                            </button>
                        </div>
                        <div className="card-body p-4">
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control w-25"
                                    placeholder="Search by name, city, email..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status"></div>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Email / Phone</th>
                                                <th>Location</th>
                                                <th>Status</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredIncubations.length > 0 ? (
                                                filteredIncubations.map((item, idx) => (
                                                    <tr key={item._id}>
                                                        <td>{idx + 1}</td>
                                                        <td className="fw-semibold">{item.name}</td>
                                                        <td>
                                                            <div>{item.email}</div>
                                                            <small className="text-muted">{item.phone}</small>
                                                        </td>
                                                        <td>{item.city}, {item.state}</td>
                                                        <td>
                                                            <span className={`badge ${item.status === 'Active' ? 'bg-success' : 'bg-secondary'}`}>
                                                                {item.status}
                                                            </span>
                                                        </td>
                                                        <td className="text-end">
                                                            <button
                                                                className="btn btn-sm btn-outline-primary me-2"
                                                                onClick={() => navigate(`/incubation/edit/${item._id}`)}
                                                            >
                                                                Edit
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-outline-danger"
                                                                onClick={() => handleDelete(item._id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4 text-muted">No incubation centers found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListIncubationCenter;